
export class GetBulkDanceEventsRequestDto {
  eventIds: string[];
  withDeleted?: boolean;
}
